import React from 'react'
import { Actions, SettlementSummary, ReservesSummary } from './BalanceSections.react'
import * as styles from './MerchantBalanceSummary.styles'
import { MERCHANT_PORTAL_API_BASE_URL } from '../../../core/main/controller/environment'

export const MerchantBalanceSummary = ({ showSettlementModal, showTaxInvoiceModal, pausedStatus, configuration, currentReserves, $scope, merchantId, rollingReserves }) => {
  if (!configuration) {
    return null
  }

  const applySettlementModal = () => {
    showSettlementModal()
    $scope.$apply()
  }

  const applyTaxInvoiceModal = () => {
    showTaxInvoiceModal()
    $scope.$apply()
  }

  const getActivityReport = (merchantId) => {
    window.location.href = `${MERCHANT_PORTAL_API_BASE_URL}/portal/merchants/${merchantId}/balance/reserves/transactions`
  }

  return (
    <div className={styles.balanceWrapper} data-testid='merchant-balance-summary__banner'>
      <SettlementSummary pausedStatus={pausedStatus} />
      <ReservesSummary
        enabled={configuration.enabled}
        currentReservesAmount={currentReserves.balance}
        rollingReservesAmount={rollingReserves.balance}
      />
      <div className={styles.emptySpace} />
      <Actions
        onViewActivityReport={() => getActivityReport(merchantId)}
        onViewSettlementReport={() => applySettlementModal()}
        onViewTaxInvoice={() => applyTaxInvoiceModal()}
        reservesEnabled={configuration.enabled}
      />
    </div>
  )
}

export default MerchantBalanceSummary
